import { Component, OnInit } from '@angular/core';
import { DEPARTMENT_TYPE_COACHTRAINING } from 'src/app/core/constants';

@Component({
    selector: 'app-coachtraining-teacher',
    templateUrl: './coachtraining-teacher.component.html',
    styleUrls: ['./coachtraining-teacher.component.scss'],
})
export class CoachtrainingTeacherComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto Capacitação
     */
    public departmentType: string = DEPARTMENT_TYPE_COACHTRAINING;
    public registerType: string = '1';

    constructor() {}

    ngOnInit(): void {
        //console.log('coachtraining-teacher');
    }
}
